// extracted by mini-css-extract-plugin
export var item = "DataList-module--item--21356";
export var key = "DataList-module--key--0da45";
export var list = "DataList-module--list--ff650";
export var val = "DataList-module--val--7579f";
export var wrap = "DataList-module--wrap--f13de";